// extracted by mini-css-extract-plugin
export default {"payments":"lf-z","header":"mf-z","adjustMarginAndPaddingNewDesign":"nf-z"};